import { cn } from '@costar-ui/cosmos';
import React__default from 'react';

/**
 * @description
 * **An atomic component that accepts an element as children and applies styles
 * to function as the preview summary of an article**
 *
 * @property {React.ReactNode} **children**
 * >Nested element between ArticlePreview tags provided by consumer
 * @property {string} **[className]**
 * >optional prop to add additional tailwind classNames (such as line-clamp)
 *
 * @example
 * <ArticlePreview className="line-clamp-4 lg:line-clamp-[9]">
 *    <Link href={articleLinkUrl}>{articlePreview}</Link>
 * </ArticlePreview>
 *
 * <ArticlePreview>
 *    <a href="/">Article preview goes here</a>
 * </ArticlePreview>
 */
var ArticlePreview = function ArticlePreview(props) {
  var children = props.children,
    className = props.className;
  return /*#__PURE__*/React__default.createElement("p", {
    className: cn("text-p-16", className)
  }, children);
};

export { ArticlePreview };
//# sourceMappingURL=article-preview.esm.js.map
